import { getCssVar } from '../../../shared/utils/cssVar';

/**
 * Returns the current gradients start and stop.
 * @returns {object} The gradient start and stop.
 */
export const getGradient = () => {
  const start = getCssVar('--c360-gradient-start');
  const end = getCssVar('--c360-gradient-end');
  return { start, end };
};
